var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 37,
    viewBox: "0 0 41 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6875 8.9375C28.6875 12.8047 23.4844 19.625 21.2344 22.4375C20.7422 23.1406 19.6875 23.1406 19.1953 22.4375C16.9453 19.625 11.8125 12.8047 11.8125 8.9375C11.8125 4.29688 15.5391 0.5 20.25 0.5C24.8906 0.5 28.6875 4.29688 28.6875 8.9375ZM20.25 11.1875C21.7969 11.1875 23.0625 9.99219 23.0625 8.375C23.0625 6.82812 21.7969 5.5625 20.25 5.5625C18.6328 5.5625 17.4375 6.82812 17.4375 8.375C17.4375 9.99219 18.6328 11.1875 20.25 11.1875ZM29.8828 13.1562C29.9531 13.0859 29.9531 13.0156 30.0234 12.9453L38.1797 9.64062C39.2344 9.21875 40.5 9.99219 40.5 11.1875V30.2422C40.5 30.9453 40.0781 31.5781 39.375 31.8594L29.25 35.8672V14.6328C29.4609 14.1406 29.6719 13.6484 29.8828 13.1562ZM10.5469 13.1562C10.7578 13.6484 10.9688 14.1406 11.25 14.6328V32.2812L2.25 35.8672C1.19531 36.2891 0 35.5156 0 34.3203V15.2656C0 14.5625 0.351562 13.9297 1.05469 13.7188L9.63281 10.2734C9.84375 11.2578 10.125 12.2422 10.5469 13.1562ZM22.9922 23.8438C23.9766 22.6484 25.5234 20.6797 27 18.4297V36.0078L13.5 32.1406V18.4297C14.9062 20.6797 16.4531 22.6484 17.4375 23.8438C18.8438 25.6719 21.5859 25.6719 22.9922 23.8438Z",
    fill: "#476930"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnMap);
export default __webpack_public_path__ + "static/media/btnMap.cd3a75f6d7f99a51904283f1e030be9d.svg";
export { ForwardRef as ReactComponent };